import { Component, Input } from '@angular/core';
import { VERIFIED_BGRS, FAILED_BGRS } from 'src/app/core/enums/background.enum';

@Component({
  selector: 'app-person-summary-card',
  templateUrl: './person-summary-card.component.html',
  styleUrls: ['./person-summary-card.component.scss']
})
export class PersonSummaryCardComponent {
  @Input() person: any = null;

  get personName(): string {
    const d = this.person?.demographics;
    return d ? `${d.firstName || ''} ${d.lastName || ''}`.trim() : '';
  }

  get personEmail(): string {
    const emails = this.person?.demographics?.emailAddresses;
    return emails?.length ? emails[0].emailAddress : '';
  }

  get bgrStatus(): string {
    return this.person?.background?.statusMessage || '';
  }

  get bgrClass(): string {
    const status = this.bgrStatus;
    if (VERIFIED_BGRS.includes(status as any)) return 'bgr-pass';
    if (FAILED_BGRS.includes(status as any)) return 'bgr-fail';
    return 'bgr-pending';
  }
}
